import React, { Component } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import { storageServices } from "../../services/storage";
// PAGE DEFAULTS
import Loader from "../../components/Loader";
import { resp } from "../../services/responseHandler";
import api from "../../api";
import AdminLayout from "../../components/adminLayout";
// PAGE DEFAULTS

export default class QueryBot extends Component {
  constructor(props) {
    super(props);
    var user = storageServices.getCurrentUser();
    const query = new URLSearchParams(this.props.location.search);
    const rec_biz_id = query.get("biz_id");
    const rec_bot_id = query.get("bot_id");

    this.state = {
      biz_id: rec_biz_id,
      bot_id: rec_bot_id,
      bot: {},
      fb_bot_status: false,
      pref_query_service: "",
      fb_page_id: "",
      fb_token: "",
      biz: {},
      messenger_share_url: "http://m.me/",
      modalShow: false,
      shareLink: <></>,
      loading: true,
      editMode: false,
    };
  }

  componentDidMount() {
    this.getBot();
    this.getBusiness();
  }

  showModal = () => {
    this.setState({ modalShow: true });
  };
  hideModal = () => {
    this.setState({ modalShow: false });
  };

  async getBusiness() {
    api.getBusinessById(this.state.biz_id).then(
      (res) => {
        console.log("Response:", res);
        let biz_data = res?.data?.data;
        this.setState({
          biz: biz_data,
          fb_page_id: biz_data?.fb_page_id,
          fb_token: biz_data?.fb_token,
          pref_query_service: biz_data?.pref_query_service,
        });
        console.log("Business data", this.state.biz);
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
      }
    );
  }

  async insertIntents() {
    let query = {
      metric: "intents",
      bot_id: this.state.bot_id,
      service_id: this.state.pref_query_service,
    };
    api.postService(`/intents/${this.state.biz_id}`, query).then(
      (res) => {
        console.log("Response:", res);
        resp.ResponseHandler(res);
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
        this.setState({ loading: false });
      }
    );
  }

  async getBot() {
    await api.getService(`/bot/${this.state.biz_id}/${this.state.bot_id}`).then(
      (res) => {
        console.log("Bot Resp:", res);
        let data = res?.data?.data;
        this.setState({
          bot: data,
        });
      },
      (error) => {
        console.log("error", error);
      }
    );
  }

  handleFacebook = (event) => {
    // this.state.biz[event.target.name] = event.target.value
    this.setState({ [event.target.name]: event.target.value });
  };

  changeBotStatus = async (status, index) => {
    this.state.channels[index].enabled = !status;
    this.setState({ channels: this.state.channels });
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    this.setState({ loading: true });
    var payload = {
      pref_query_service: this.state.pref_query_service,
      fb_page_id: this.state.fb_page_id,
      fb_token: this.state.fb_token,
    };
    api.updateBusinessByID(this.state.biz._id, payload).then(
      (res) => {
        console.log("Response:", res);
        this.insertIntents();
      },
      (error) => {
        console.log("error", error);
        resp.ErrorHandler(error);
        this.setState({ loading: false });
      }
    );
  };

  updateRecord = async () => {
    this.setState({ loading: true });
    var payload = {
      pref_query_service: this.state.pref_query_service,
      fb_page_id: this.state.fb_page_id,
      fb_token: this.state.fb_token,
    };
    api.updateBusinessByID(this.state.biz._id, payload).then(
      (res) => {
        console.log("Response:", res);
        resp.ResponseHandler(res);
        this.setState({ loading: false });
      },
      (error) => {
        console.log("error", error);
        this.setState({ loading: false });
      }
    );
  };

  updateBotStatus = (status) => {
    this.setState({ loading: true });
    let query = { status: status };
    api
      .putService(
        `/activate_bot/${this.state.bot.biz_id}/${this.state.bot.id}`,
        query
      )
      .then(
        (res) => {
          console.log("Response:", res);
          resp.ResponseHandler(res);
          this.setState({ loading: false });
        },
        (error) => {
          console.log("error", error);
          resp.ErrorHandler(error);
          this.setState({ loading: false });
        }
      );
  };

  deleteBot = () => {
    this.setState({ loading: true });
    let query = {};
    api
      .deleteService(
        `/bot/${this.state.bot.biz_id}/${this.state.bot.id}`,
        query
      )
      .then(
        (res) => {
          console.log("Response:", res);
          this.setState({ loading: false });
          resp.ResponseHandler(res, null);
          this.props.history.goBack();
        },
        (error) => {
          console.log("error", error);
          resp.ErrorHandler(error);
          this.setState({ loading: false });
        }
      );
  };

  openSetupBot = () => {
    this.setState({ editMode: false });
    this.showModal();
  };

  openUpdateBot = () => {
    this.setState({ editMode: true });
    this.showModal();
  };

  render() {
    const {
      biz_rules,
      facebook,
      channels,
      biz,
      shareLink,
      fb_token,
      fb_page_id,
      pref_query_service,
      modalShow,
      editMode,
    } = this.state;
    return (
      <AdminLayout>
        {this.state.loading ? <Loader /> : ""}
        <div className="row mb-5">
          <div className="col my-auto">
            <div className="buttons float-left">
              <button
                className="btn text-dark"
                onClick={this.props.history.goBack}
              >
                <i class="fa fa-chevron-circle-left" aria-hidden="true"></i> Go
                back
              </button>
            </div>
          </div>
          <div className="col my-auto text-center mx-auto clearfix">
            <img
              src="https://cdn-icons-png.flaticon.com/512/1786/1786548.png"
              className="img-fluid img-bot mr-3"
            />
            <span className="text-primary">
              <b>Query Bot</b>
            </span>
          </div>

          <div className="col my-auto text-center">
            <button
              type="button"
              class="btn btn-outline-danger"
              onClick={() => this.deleteBot()}
            >
              Delete Bot
            </button>
          </div>
        </div>
        {!biz?.pref_query_service && (
          <div class="row mx-auto my-auto">
            <div class="col-sm-12">
              <div class="text-center">
                <button
                  type="button"
                  class="btn btn-primary"
                  onClick={() => this.openSetupBot()}
                >
                  <i class="fa fa-wrench" aria-hidden="true"></i>&nbsp;Setup
                </button>
              </div>
            </div>
          </div>
        )}

        {biz?.pref_query_service && biz?.pref_query_service != "" && (
          <div className="row w-100 mx-0">
            <div className="col-lg-8 mx-auto">
              <div className="card text-left py-5 px-4 px-sm-5">
                <form>
                  <div class="form-group row">
                    <label class="col-sm-2 col-form-label text-muted">
                      Preferred service
                    </label>
                    <p class="col-form-label">{biz?.pref_query_service}</p>
                  </div>

                  {biz?.pref_query_service === "facebook" && (
                    <>
                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          FB Page Id
                        </label>
                        <p class="col-form-label">{biz?.fb_page_id}</p>
                      </div>

                      <div class="form-group row">
                        <label class="col-sm-2 col-form-label text-muted">
                          API Token
                        </label>
                        <p class="col-form-label text-wrap text-truncate">
                          {biz?.fb_token}
                        </p>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        )}

        <Modal show={modalShow} onHide={this.hideModal}>
          <Modal.Header closeButton>
            <Modal.Title>Query bot setup</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={!editMode ? this.handleSubmit : this.updateRecord}>
              <div class="form-group">
                <label for="pref_service">Preferred service</label>
                <select
                  class="form-control"
                  name="pref_query_service"
                  id="pref_query_service"
                  value={pref_query_service}
                  onChange={this.handleFacebook}
                  required
                >
                  <option value="" selected disabled></option>
                  <option value="facebook">Facebook</option>
                </select>
              </div>
              {pref_query_service === "facebook" && (
                <>
                  <div class="form-group">
                    <label for="exampleInputEmail1">Facebook Page ID</label>
                    <input
                      type="text"
                      name="fb_page_id"
                      value={fb_page_id}
                      className="form-control"
                      placeholder="(e.g: 100169198193069)"
                      onChange={this.handleFacebook}
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">API Token</label>
                    <textarea
                      type="text"
                      name="fb_token"
                      value={fb_token}
                      className="form-control"
                      onChange={this.handleFacebook}
                      required
                    />
                  </div>
                </>
              )}
              <div className="float-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-3"
                  onClick={this.hideModal}
                >
                  Close
                </button>
                {editMode ? (
                  <button type="submit" className="btn btn-primary">
                    Update
                  </button>
                ) : (
                  <button type="submit" className="btn btn-primary">
                    Save
                  </button>
                )}
              </div>
            </form>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button variant="secondary" onClick={this.hideModal}>
              Close
            </Button>
            <Button variant="primary" type="submit" onClick={this.handleSubmit}>
              Save
            </Button>
          </Modal.Footer> */}
        </Modal>
      </AdminLayout>
    );
  }
}
